import { AfterViewInit, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
//import { DialogPosition, MatDialog, MatDialogConfig } from '@angular/material/dialog';
//import { CookiesDisclaimerDialogComponent } from './components/footer/cookies-disclaimer-dialog/cookies-disclaimer-dialog.component';
import { WinoCookieService } from './modules/wino-shared/services/wino-cookie.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent  implements AfterViewInit /* OnInit, OnChanges, DoCheck, AfterContentInit, AfterContentChecked, AfterViewInit, AfterViewChecked, OnDestroy*/ {
    

    title = 'wino-frontend';

    @ViewChild("acceptCookiesModalButton")
    acceptCookiesModalButton: ElementRef;
    
    constructor(/*private matDialog: MatDialog, */private cookieService: WinoCookieService) { }

    ngAfterViewInit(): void {
        //enableProdMode();
        if (!this.cookieService.disclaimerViewed()) {
            this.acceptCookiesModalButton.nativeElement.click();
        } else {
            this.cookieService.logDisclaimerCookies();
        }
    }

    acceptCookies(result: boolean): void {
        (this.inputValueIsEmpty(result) || result) ? this.cookieService.acceptCookies() : this.cookieService.refuseCookies();
    }

/****************************************
    openCookiesDialog() {
        const dialogConfig: MatDialogConfig = new MatDialogConfig();
        const dialogPosition: DialogPosition = {bottom: '12px'};
        dialogConfig.maxWidth = "80%";
        dialogConfig.minHeight = "10%";
        dialogConfig.position = dialogPosition;
        //dialogConfig.backdropClass = 'backdropBackground';
        const dialogRef = this.matDialog.open(CookiesDisclaimerDialogComponent, dialogConfig);

        dialogRef.afterClosed().subscribe(result => {
            let acceptCookies: boolean;
            acceptCookies = result;
            (this.inputValueIsEmpty(acceptCookies) || acceptCookies) ? this.cookieService.acceptCookies() : this.cookieService.refuseCookies();
        });
    }
********************************************/

    inputValueIsEmpty(value: any): boolean {
        // we don't check for string here so it also works with arrays
        return (value === null || value === undefined || value.length === 0 || value === '' || value === 0);
    }

/**********************************************************************
    ngOnChanges(): void {
        console.log("APP COMPONENT - OnChanges");
    }

    ngDoCheck(): void {
        console.log("APP COMPONENT - DoCheck");
    }

    ngAfterContentInit(): void {
        console.log("APP COMPONENT - AfterContentInit");
    }

    ngAfterContentChecked(): void {
        console.log("APP COMPONENT - AfterContentChecked");
    }

    ngAfterViewInit(): void {
        console.log("APP COMPONENT - AfterViewInit");
    }

    ngAfterViewChecked(): void {
        console.log("APP COMPONENT - AfterViewChecked");
    }

    ngOnDestroy(): void {
        console.log("APP COMPONENT - OnDestroy");
    }
 *************************************************************************/

}